<template>
  <div class="container unprint">
    <div class="row">
      <div class="common__title-result">
        Альбомы и инструкции по материалам и монтажу
      </div>
    </div>
    <div class="row addons">
      <div class="col-lg-6 col-12 addons__item"
           v-for="n in albums.length" :key="n">
        <a :href="getAlbum(albums[n-1]).link" class="addons__link" target="_blank">
          <img src="@/assets/img/download.svg" alt="downlad" class="addons__link-img">
          {{ getAlbum(albums[n-1]).name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  props: {
    materialProp: Number,
    isInDetails: Boolean,
    resultAlbums: Array,
  },
  data() {
    return {
    };
  },
  methods: {
    getAlbum(id) {
      return this.allAlbums[this.allAlbums.findIndex(p => p.id === id)];
    },
  },
  components: {
  },
  computed: {
    ...mapState({
      allAlbums: state => state.albums,
      result: state => state.result,
    }),
    sectorId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    sectorResultFromState() {
      return this.$store.getters.getSectorResult(this.sectorId);
    },
    albums() {
      if (this.isInDetails) {
        return this.sectorResultFromState.albums;
      } return this.resultAlbums;
    },
  },
};
</script>

<style lang="sass" scoped>
  .detailsPage
    .slopePage
      &__title
        +media((font-size: (320: rem(18), 992: rem(24))))
        +media((line-height: (320: rem(26), 992: rem(29))))
        +media((padding-top: (320: rem(45), 992: rem(70))))
        +media((padding-bottom: (320: rem(30), 992: rem(36))))
</style>
